import React, { useState } from 'react';

import { Box } from '@mui/material';

import {
  AssignmentOutlined,
  DescriptionOutlined,
  FactCheckOutlined,
  MedicalInformationOutlined,
  ScienceOutlined
} from '@mui/icons-material';

import PageHeaderTabs from '../Common/components/PageHeaderTabs';

import {
  AssessmentPlan,
  CPT,
  ICD10,
  Objective
} from './components';

import Subjective from './components/Subjective/Subjective';
import TemplateContentWrapper from './components/TemplateContentWrapper';

import { templatePageSx } from './TemplateStyles';

import {
  patientPageContentSx
} from '../Common/components/Styles/PatientPageStyles';

const templateTabs = [
  {
    value: 0,
    label: 'Subjective',
    title: 'Subjective Template - User Defined',
    icon: <DescriptionOutlined />,
    component: Subjective
  },
  {
    value: 1,
    label: 'Objective',
    title: 'Objective Template - User Defined',
    icon: <AssignmentOutlined />,
    component: Objective
  },
  {
    value: 2,
    label: 'Assessment Plan',
    title: 'Assessment Plan Template - User Defined',
    icon: <FactCheckOutlined />,
    component: AssessmentPlan
  },
  {
    value: 3,
    label: 'ICD10',
    title: 'ICD10 Template - User Defined',
    icon: <MedicalInformationOutlined />,
    component: ICD10
  },
  {
    value: 4,
    label: 'CPT',
    title: 'CPT Template - User Defined',
    icon: <ScienceOutlined />,
    component: CPT
  }
];

const Default = () => {
  const [tab, setTab] = useState(0);

  const activeTab =
    templateTabs.find(
      item => item.value === tab
    ) || templateTabs[0];

  const ActiveComponent =
    activeTab.component;

  return (
    <Box sx={templatePageSx}>
      <PageHeaderTabs
        type="tabs"
        value={tab}
        tabs={templateTabs}
        onChange={(event, newValue) => {
          setTab(newValue);
        }}
      />

      <Box
        sx={{
          ...patientPageContentSx,

          flex: 1,
          minHeight: 0,

          display: 'flex',

          overflow: 'hidden'
        }}
      >
        <TemplateContentWrapper
          title={activeTab.title}
        >
          <ActiveComponent />
        </TemplateContentWrapper>
      </Box>
    </Box>
  );
};

export default Default;